import React from 'react';

const InsightsPanel = () => {
  const insights = [
    {
      title: "Documentation time decreased 23% since implementing OncoCatalyst",
      type: "improvement"
    },
    {
      title: "Thursday afternoons show highest bottlenecks",
      type: "issue"
    },
    {
      title: "15% increase in patient satisfaction scores",
      type: "improvement"
    }
  ];
  
  const recommendations = [
    {
      text: "Consider adjusting Thursday scheduling",
      type: "scheduling"
    },
    {
      text: "Room 3 could be better utilized",
      type: "resource"
    }
  ];
  
  return (
    <div className="bg-gray-200 p-4 h-full">
      <h2 className="text-lg font-medium text-gray-700 mb-4">Insights:</h2>
      
      <div className="space-y-4 mb-6">
        {insights.map((insight, index) => (
          <div key={index} className="bg-white p-3 rounded shadow">
            <p className={`${insight.type === 'improvement' ? 'text-green-600' : 'text-orange-600'}`}>
              {insight.title}
            </p>
          </div>
        ))}
      </div>
      
      <h2 className="text-lg font-medium text-gray-700 mb-4">Recommendations:</h2>
      
      <div className="space-y-4">
        {recommendations.map((rec, index) => (
          <div key={index} className="bg-white p-3 rounded shadow">
            <p className="text-gray-800">{rec.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsPanel;